import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setOverlayPartnerVisible } from './actions.js';
import OverlayGeneric from '../../components/Overlay/OverlayGeneric';
import PartnerLogo from '../../components/Donation/PartnerLogo';
import PartnerDescription from '../../components/Overlay/CustomDescription';

const Overlay = props => {
    return (
        <OverlayGeneric
            isPartnerOrPublisherOverlay={true}
            logoComponent={PartnerLogo}
            aboutUsComponent={PartnerDescription}
            aboutUsContent={{
                description: props.partnerDescription,
                logoUrl: props.partnerLogoUrl
            }}
            logoIsSmall={props.logoIsSmall}
            isVisible={props.isVisible}
            isMobileResolution={props.isMobileResolution}
            setOverlayVisible={props.setOverlayPartnerVisible}
            transitionType={props.transitionType}
            title={props.title}
            logo={props.logo}
            name={props.name}
            description={props.description}
            isActionChoiceOverlay={props.isActionChoiceOverlay}
            widgetId={props.widgetId}
        />
    );
};

Overlay.propTypes = {
    description: PropTypes.string,
    isActionChoiceOverlay: PropTypes.bool,
    isMobileResolution: PropTypes.bool.isRequired,
    isVisible: PropTypes.bool,
    logo: PropTypes.string,
    logoIsSmall: PropTypes.bool,
    name: PropTypes.string,
    partnerDescription: PropTypes.string.isRequired,
    partnerLogoUrl: PropTypes.string.isRequired,
    setOverlayPartnerVisible: PropTypes.func.isRequired,
    title: PropTypes.string,
    transitionType: PropTypes.string.isRequired,
    widgetId: PropTypes.number.isRequired
};

export default connect(
    (state, props) => {
        const partner = props.isActionChoiceOverlay
            ? state.actionChoiceCard.partner || {}
            : state.widget.selectedPartner || {};
        return {
            widgetId: state.widget.widgetId,
            isVisible: props.isActionChoiceOverlay
                ? state.widget.isActionChoiceOverlayVisible
                : state.widget.isOverlayPartnerVisible,
            isPartnerOverlayTransitionRegular:
                state.widget.isPartnerOverlayTransitionRegular,
            isMobileResolution: state.widget.isMobileResolution,
            partnerDescription: partner.description || '',
            partnerLogoUrl: partner.logoUrl || '',
            title: partner.showNameWithLogo ? partner.name || '' : ''
        };
    },
    { setOverlayPartnerVisible }
)(Overlay);
